import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const ModalContentWrapper = styled.div`
  font-family: ${(props) => props.theme.font.family};
  background: #fff;
  padding: 25px 25px 100% 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 80px 60px;
  }
`;

const Description = styled.div`
  font-weight: ${(props) => props.theme.font.weight.v300};
  ${(props) => props.theme.font.heading.v100};
  color: ${(props) => props.theme.color.primary.v600};
  padding: 15px 0 35px;
  text-align: center;
  text-transform: uppercase;
  width: 300px;
  line-height: 24px;
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    width: 400px;
  }
`;

const DetailsRow = styled.div`
  display: flex;
  padding-bottom: 40px;
  width: 100%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  align-items: center;

  &:first-child {
    border-right: 1px solid ${(props) => props.theme.color.neutral.v300};
  }
`;

const ColumnTitle = styled.div`
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.label.v200};
  color: ${(props) => props.theme.color.neutral.v500};
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    ${(props) => props.theme.font.body.v300};
  }
`;

const ColumnData = styled.p`
  padding-top: 5px;
  margin: 0;
  ${(props) => props.theme.font.label.v300};
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: ${(props) => props.theme.font.weight.v300};
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    ${(props) => props.theme.font.heading.v400};
  }
`;

const ConfirmButton = styled(PrimaryButton)`
  width: 330px;
  height: 55px;
  color: ${(props) => props.theme.color.neutral.v100};
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 100%;
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 360px;
  }
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    width: 250px;
    margin-bottom: 0;
  }
`;

export {
  ModalContentWrapper,
  Description,
  DetailsRow,
  Column,
  ColumnTitle,
  ColumnData,
  ConfirmButton,
};
